import React from 'react';
import { toast } from 'react-toastify';

import ToastMsg from './msg';

export const REACT_TOASTIFY_CONTAINER_ID = 'shopper-toast-container';

const toastPosition = (position) => {
  let returnPostion;
  switch (position) {
    case 'top-left':
      returnPostion = toast.POSITION.TOP_LEFT;
      break;
    case 'top-center':
      returnPostion = toast.POSITION.TOP_CENTER;
      break;
    case 'top-right':
      returnPostion = toast.POSITION.TOP_RIGHT;
      break;
    case 'bottom-left':
      returnPostion = toast.POSITION.BOTTOM_LEFT;
      break;
    case 'bottom-center':
      returnPostion = toast.POSITION.BOTTOM_CENTER;
      break;
    default:
      returnPostion = toast.POSITION.TOP_RIGHT;
  }
  return returnPostion;
};
/**
 * Represents a Custom Toast Component.
 * @param {Object} props Props Object.
 * @param {string} props.msg - Message which you want to display on text.
 * @param {string} props.position - Postion where you want to be toast placed.
 * @param {number | false} props.autoClose - Duration in milliseconds before the toast automatically closes, or false to disable auto close.
 * @param {string} props.type - toast is type of success,error,warn and info
 */
export default function CustomToast({ msg, type, position, autoClose }) {
  return toast(<ToastMsg msg={msg} type={type} />, {
    containerId: REACT_TOASTIFY_CONTAINER_ID,
    position: toastPosition(position),
    className: 'customToast',
    progressClassName: 'customToast__progress-bar',
    bodyClassName: 'customToast__body',
    autoClose,
  });
}
